export default "__VITE_ASSET__LDHm5hls__"